module.exports = __webpack_public_path__ + "media/images/projects/14-header-6fb98a9d97fc3daf205efd448391cf68.jpg";